import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  fetching: true,
  liveFeed: [],
  error: null,
  liveFeedTags: []
}

const liveFeedSlice = createSlice({
  name: 'liveFeedReducer',
  initialState,
  reducers: {
    requestLiveFeed: (state, { payload }) => {
      state.fetching = true
      state.liveFeedTags = payload
    },
    requestLiveFeedSuccess: (state, { payload }) => {
      state.fetching = false
      //Only refresh the Live Feed if there are actual values
      if (payload?.length > 0) state.liveFeed = payload
    },
    requestLiveFeedFailed: state => {
      state.fetching = false
      state.liveFeed = []
      state.error = 'failed to get livefeed'
    }
  }
})

export const { actions, reducer } = liveFeedSlice

export const {
  requestLiveFeed,
  requestLiveFeedSuccess,
  requestLiveFeedFailed
} = actions

export default reducer
